import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAdvertisersList, setAdvertiserDetails } from 'modules/advertisers/actions';
import AdvertisersComponent from 'modules/advertisers/components/AdvertisersComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AdvertisersContainer = ({ advertisersListApiCallBody }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPageFilter, setSelectedPageFilter] = useState(1);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // eslint-disable-next-line no-unused-vars
  const submitSearchQuery = reset => {
    // setSelectedPageFilter(1);
    // const body = {
    //   ...ordersApiCallParams,
    // };
    // if (searchQuery) body.searchTerm = searchQuery;
    // if (reset) delete body.searchTerm;
    // setOrdersApiCallParams(body);
    // dispatch(fetchAllOrders(body));
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleAddAdvertiserBtnClick = () => {
    navigate('/addAdvertiser');
  };

  const handleEditAdvertiserBtnClick = advertiser => {
    const { advertiserKey, name, phone, email } = advertiser;

    dispatch(setAdvertiserDetails({ name, phone, email }));
    navigate(`/addAdvertiser/${advertiserKey}`);
  };

  const handleAddCampaignBtnClick = advertiserKey => {
    navigate(`/addCampaign?advertiserKey=${advertiserKey}`);
  };

  const handleViewCampaignsBtnClick = advertiserKey => {
    navigate(`/campaigns?advertiserKey=${advertiserKey}`);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;
    const searchQueryMinLength = 3;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        submitSearchQuery();
      }, 300);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      submitSearchQuery(true);
  };

  const handleOrderPaginationClick = selectedPageNumber => {
    setSelectedPageFilter(selectedPageNumber);

    const data = {
      ...advertisersListApiCallBody,
    };
    data.page = selectedPageNumber;
    const body = {
      data,
    };

    dispatch(fetchAdvertisersList(body));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <AdvertisersComponent
      searchQuery={searchQuery}
      selectedPageFilter={selectedPageFilter}
      handleAddAdvertiserBtnClick={handleAddAdvertiserBtnClick}
      handleEditAdvertiserBtnClick={handleEditAdvertiserBtnClick}
      handleAddCampaignBtnClick={handleAddCampaignBtnClick}
      handleViewCampaignsBtnClick={handleViewCampaignsBtnClick}
      handleSearchBarInputChange={handleSearchBarInputChange}
      handleOrderPaginationClick={handleOrderPaginationClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AdvertisersContainer.propTypes = {
  advertisersListApiCallBody: PropTypes.shape({}).isRequired,
};

AdvertisersContainer.defaultProps = {};

export default AdvertisersContainer;
